import { apiFetch } from './api';

export interface OverviewKpi {
  activePersons: number;
  activePersonsDeltaPct: number;
  mrrCents: number;
  mrrDeltaPct: number;
  gross30dCents: number;
  gross30dDeltaPct: number;
  newPersons7d: number;
  newPersons7dDeltaWoWPct: number;
  churn30dPct: number;
  churn30dDeltaPp: number;
  arpuCents: number;
  arpuDeltaPct: number;
  lastEventAt: string | null;
  dataStartAt: string | null;
  dataEndAt: string | null;
}

export interface DailyPoint {
  day: string;
  grossCents: number;
  refundCents: number;
  newPersons: number;
}

export interface FunnelSnapshot {
  slug: string;
  name: string;
  isActive: boolean;
  conversionPct: number;
  stages: { slug: string; name: string; ordinal: number; count: number; pctOfEntry: number }[];
}

export function fetchOverviewKpi(): Promise<OverviewKpi> {
  return apiFetch<OverviewKpi>('/kpi/overview');
}

export async function fetchDaily(rangeDays = 3650): Promise<DailyPoint[]> {
  // Дефолт = "усі дані" (10 років). API розширює до min/max з payments автоматично.
  const r = await apiFetch<{ days: DailyPoint[] }>(`/kpi/daily?rangeDays=${rangeDays}`);
  return r.days;
}

export async function fetchFunnelSnapshot(rangeDays = 7): Promise<FunnelSnapshot[]> {
  const r = await apiFetch<{ items: FunnelSnapshot[] }>(
    `/funnels/snapshot?rangeDays=${rangeDays}`,
  );
  return r.items;
}
